export default context => {
    if ($(context).hasClass('restricted')) {
        // disable content links
        $('a[href^="http"]', context).attr('href', 'javascript:;');
        // disable on click for external subscribe
        $('li.restricted a', context).off('click').on('click', () => false);
    }
};
